<template>
  <QuickContactBar></QuickContactBar>
  <NavBar></NavBar>
  <div class="container-xxl bg-white p-0">
  <router-view></router-view>
</div>
  <FooterBar></FooterBar>
</template>

<script>
import NavBar from './components/NavBar.vue'
import FooterBar from './components/FooterBar.vue'
import QuickContactBar from './components/QuickContactBar.vue'

export default {
  name: 'App',
  components: {
    NavBar, FooterBar, QuickContactBar
  }
}
</script>
<style>

@import "@/assets/css/bootstrap.min.css";
@import "@/assets/css/style.css";
</style>
